module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }]
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Parâmetros Gerais\n            ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7732b922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/configuracao/index.vue
// module id = 1512
// module chunks = 45